<template>
  <div class="app-container">
    <div class="toolbar">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-form-item label="巡检时间" prop="workTimevalue" class="orderTimevalueStyle">
          <el-date-picker
            v-model="workTimevalue"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="巡检点" prop="inspectionId">
          <el-select
            v-model="queryParams.inspectionId"
            placeholder="请选择巡检点"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option v-for="item in inspectionList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检人" prop="userName">
          <el-input
            v-model="queryParams.userName"
            placeholder="请输入巡检人"
            clearable
            @keyup.enter.native="handleQuery('up')"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="queryParams.status" size="mini">
            <el-radio border :label="0" style="margin-right: 0;">全部</el-radio>
            <el-radio border :label="1" style="margin-right: 0;">正常</el-radio>
            <el-radio border :label="2">异常</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery('up')">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table :data="tableData.list" stripe height="450" :size="size">
        <el-table-column prop="companyName" label="所属公司" width="150" show-overflow-tooltip />
        <el-table-column prop="inspectionName" label="巡检点" width="150" show-overflow-tooltip />
        <el-table-column prop="userName" label="巡检人" width="150" show-overflow-tooltip />
        <el-table-column prop="locationName" label="照片" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <image-preview :src="row.img" :width="40" :height="40"></image-preview>
          </template>
        </el-table-column>
        <el-table-column prop="locationName" label="状态" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status == 1">正常</el-tag>
            <el-tag type="warning" v-if="row.status == 2">异常</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="150" show-overflow-tooltip />
        <el-table-column prop="createTime" label="巡检时间" minwidth="250" show-overflow-tooltip />
        <el-table-column label="操作" fixed="right" width="210">
          <template slot-scope="scope">
            <el-button icon="el-icon-search" circle size="mini" @click="handleDetail(scope.row)" />
            <el-button type="primary" size="mini" @click="handleTrack(scope.row)">轨迹</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="toolbar" style="padding: 10px" v-if="tableData.total > 0">
        <pagination
          :total="tableData.total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="handleQuery"
        />
      </div>
    </div>
    <el-drawer :title="title" :visible.sync="openDrawer" destroy-on-close class="editdrawer OA" size="32%">
      <div class="xiangqing">
        <el-form
          :model="form"
          :rules="formRules"
          label-width="120px"
          ref="form"
          label-position="left"
          style="margin-bottom: 45px"
          :disabled="title == '详情'"
        >
          <el-form-item label="所属公司" prop="companyName">
            <el-input v-model="form.companyName" placeholder="所属公司" />
          </el-form-item>
          <el-form-item label="巡检点" prop="inspectionName">
            <el-input v-model="form.inspectionName" placeholder="巡检点" />
          </el-form-item>
          <el-form-item label="巡检人" prop="userName">
            <el-input v-model="form.userName" placeholder="巡检人" />
          </el-form-item>
          <el-form-item label="巡检时间" prop="createTime">
            <el-input v-model="form.createTime" placeholder="巡检时间" />
          </el-form-item>
          <el-form-item label="巡检状态" prop="status">
            <el-radio-group v-model="form.status" size="mini">
              <el-radio border :label="1" style="margin-right: 0;">正常</el-radio>
              <el-radio border :label="2">异常</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="照片" prop="img">
            <div v-if="form.img">
              <div v-for="(item, index) in form.img.split(',')" :key="index + 'aaa'" style="float: left;margin:5px;">
                <image-preview :src="item" :width="50" :height="50"></image-preview>
              </div>
            </div>
            <div v-else>未上传</div>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" autosize v-model="form.remark" placeholder="备注" />
          </el-form-item>
          <el-form-item label="巡检点位置" prop="userLocation">
            <el-input type="textarea" autosize v-model="form.userLocation" placeholder="巡检点位置" />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" v-if="title != '详情'">
          <el-button @click="openDrawer = false">取消</el-button>
          <el-button :loading="loading" type="primary" @click="submitForm()">保存</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 定位经纬度 -->
    <el-dialog title="标记坐标点" width="80%" height="100%" :visible.sync="dialogVisibles" append-to-body class="map">
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="dialogVisibles = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 巡检轨迹 -->
    <el-dialog width="70%" :visible.sync="dialogTrajectory" class="transport siandaoinfoWork">
      <template slot="title">
        <div class="avue-crud__dialog__header">
          <span class="el-dialog__title">
            巡检轨迹
            <el-date-picker
              :clearable="false"
              size="mini"
              v-model="workTimevalue2"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              @change="getWorkTimevalue2"
            >
            </el-date-picker>
          </span>
        </div>
      </template>
      <trajectory-maps ref="child" :mapBoxStyle.sync="mapBoxStyle" :workInfo.sync="workInfo"></trajectory-maps>
    </el-dialog>
  </div>
</template>

<script>
import mapUpdata from '@/components/mapUpdata'
import trajectoryMaps from './components/trajectoryMaps'
import { sysInspectionRecordList, sysInspectionRecordDelete, sysInspectionList } from '@/api/clockIn'
import axios from 'axios'
export default {
  components: {
    mapUpdata,
    trajectoryMaps,
  },
  data() {
    return {
      size: 'mini',
      title: '',
      loading: false,
      openDrawer: false,
      dialogVisibles: false,
      dialogTrajectory: false,
      inspectionList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: null,
        status: 0,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      },
      tableData: {},
      form: {},
      formRules: {},
      enterType: '',
      workTimevalue: [], //巡检日期
      workTimevalue2: [], //巡检轨迹
      workInfo: {
        userLocation: '',
      },
      mapBoxStyle: {},

      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.getInspection()
    this.handleQuery()
  },
  methods: {
    // 获取巡检点
    getInspection(part) {
      sysInspectionList({
        pageNum: 1,
        pageSize: 999,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      }).then((res) => {
        if (res.code == 200) {
          this.inspectionList = res.data.list
        }
      })
    },
    // 查询
    handleQuery(part) {
      if (part == 'up') {
        this.queryParams.pageNum = 1
      }
      // 巡检日期
      if (this.workTimevalue == null) {
        this.queryParams.endTime = undefined
        this.queryParams.beginTime = undefined
      } else {
        if (this.workTimevalue[1] != undefined) {
          this.queryParams.endTime = this.workTimevalue[1] + ' 23:59:59'
          this.queryParams.beginTime = this.workTimevalue[0] + ' 00:00:00'
        } else {
          // this.filters.endTime = '';
          // this.filters.startTime = '';
        }
      }
      sysInspectionRecordList(this.queryParams).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      })
    },
    //详情
    handleDetail(row) {
      this.title = '详情'
      this.openDrawer = true
      this.form = Object.assign({}, row)
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认要删除此项吗？', '提示', {}).then(() => {
        sysInspectionRecordDelete({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({ message: '删除成功', type: 'success' })
            this.handleQuery()
            this.$refs['form'].resetFields()
          } else {
            this.$message({ message: '删除失败, ' + res.msg, type: 'error' })
          }
        })
      })
    },
    // 巡检轨迹 选择日期
    getWorkTimevalue2(val) {
      this.workTimevalue2 = val
      // 巡检日期
      if (this.workTimevalue2 == null) {
        var endTime = undefined
        var beginTime = undefined
      } else {
        if (this.workTimevalue2[1] != undefined) {
          var endTime = this.workTimevalue2[1] + ' 23:59:59'
          var beginTime = this.workTimevalue2[0] + ' 00:00:00'
        }
      }
      this.workInfo.beginTime = beginTime
      this.workInfo.endTime = endTime
      setTimeout(() => {
        this.$refs.child.findPage()
      }, 500)
    },
    // 巡检点轨迹
    handleTrack(val) {
      this.mapBoxStyle = {
        width: '100%',
        height: '63vh',
      }
      this.workTimevalue2 = [val.createTime.slice(0, 10)+' 00:00:00', val.createTime.slice(0, 10)+' 23:59:59']
      // 巡检日期
      console.log(this.workTimevalue2)
      let endTime = val.createTime.slice(0, 10)+' 23:59:59'
      let beginTime = val.createTime.slice(0, 10)+' 00:00:00'
      this.workInfo = {
        userName: val.userName,
        userId: val.userId,
        beginTime:beginTime,
        endTime:endTime,
        userLocation: val.userLocation,
      }
      this.dialogTrajectory = true
      setTimeout(() => {
        this.$refs.child.findPage()
      }, 500)
    },
    // 获取当前年月日
    getNowFormatDate() {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，需要加1，并补零
      const day = String(date.getDate()).padStart(2, '0') // 补零
      return `${year}-${month}-${day}`
    },
  },
}
</script>
<style lang="less" scoped></style>
